module.exports = __webpack_public_path__ + "static/img/iec27001-1.5ac63eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iec27001-1.png
// module id = dHIN
// module chunks = 1